import React from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "./components/Layout/Layout";
import NoPage from "./pages/404";
import Main from "./pages/Main/Main";
import Legacy from "./pages/Legacy";

const Router = (): JSX.Element => (
    <Routes>
        <Route path="/" element={<Layout />}>
            <Route index element={<Main />} />
            <Route path="/discover" element={<Main />} />
            <Route path="/error" element={<Main />} />
            <Route path="/develop" element={<Legacy />}> </Route>
            <Route path="design-system"></Route>
            <Route path="*" element={<NoPage />} />
        </Route>
    </Routes>
);

export default Router;